module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-04-m.0083696e9469c45a907aba8b45a8348c.png";